import { onMounted } from 'vue'

export default function (plugin_url: string) {
    // Set backgroud image on body
    onMounted(() => {
        document.body.style.backgroundImage = `url(${plugin_url}/public/images/bg-shapes.jpg)`
    })
}
